<template>
  <div class="page-container">
    <van-nav-bar
      title="邀请列表"
      fixed
      left-arrow
      @click-left="goableBack()"
      :z-index="10"
      @click-right="toggleSearchForm"
    >
      <template #right> <van-icon name="search" size="18" /> </template
    ></van-nav-bar>
    <div class="page">
      <div v-show="this.showSearch" class="search-form">
        <van-form style="font-size: 6px">
          <van-field
            clearable
            v-model="queryParams.name"
            name="name"
            label="用户名"
            placeholder="请输入需要查找的用户名"
          />
          <van-field
            clearable
            v-model="queryParams.phone"
            name="phone"
            label="手机号"
            placeholder="请输入需要查找的手机号"
          />
        </van-form>
        <van-row type="flex" justify="center" align="center">
          <van-col type="flex" justify="center" align="center">
            <van-button icon="replay" class="search-btn" @click="reset"
              >重置</van-button
            >
            <van-button
              icon="search"
              class="search-btn"
              type="info"
              @click="search"
            >
              搜索
            </van-button>
          </van-col>
        </van-row>
      </div>

      <van-pull-refresh
        :class="pullRefreshStyle"
        v-model="refreshing"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          @load="onload"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
          :finished-text="'加载完毕总共' + this.total + '条'"
        >
          <van-cell v-for="item in data" :key="item.id">
            <div class="item-container">
              <van-row type="flex" justify="center" align="center">
                <van-col span="4">
                  <van-icon
                    name="https://b.yzcdn.cn/vant/icon-demo-1126.png"
                    size="1rem"
                  />
                </van-col>
                <van-col span="20">
                  <van-cell
                    title="手机号"
                    :value="item.phone"
                    value-class="cell-value-class"
                    title-class="cell-value-class"
                  ></van-cell>
                  <van-cell
                    title="姓名"
                    :value="item.name"
                    title-class="cell-value-class"
                    value-class="cell-value-class"
                  ></van-cell>
                  <van-cell
                    title="用户ID"
                    :value="item.id"
                    title-class="cell-value-class"
                    value-class="cell-value-class"
                  ></van-cell>
                  <van-cell
                    value-class="cell-value-class"
                    title="注册时间"
                    title-class="cell-value-class"
                    :value="item.registerTime"
                  ></van-cell>
                </van-col>
              </van-row>
            </div>
            <van-row> </van-row>
          </van-cell>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>


<script>
import { List, Toast, PullRefresh, Row, Col, Icon, Form, Field } from "vant";
import * as CustApi from "@/api/cust";
import { scrollTo } from "../../utils/scroll-to";
import { mapGetters } from "vuex";
import { queryOrder } from "../../api/goods";
export default {
  name: "MyInviteList",
  components: {
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Form.name]: Form,
    [Field.name]: Field,
    [Toast.name]: Toast,
  },
  data() {
    return {
      data: [],
      error: false,
      loading: false,
      finished: false,
      refreshing: false,
      total: 0,
      showSearch: false,
      queryParams: {
        name: "",
        phone: "",
        currPage: 0,
        pageSize: 15,
      },
    };
  },
  methods: {
    toggleSearchForm() {
      this.showSearch = !this.showSearch;
      if (!this.showSearch) {
        this.queryParams.name = "";
        this.queryParams.phone = "";
      }
    },

    async reset() {
      try {
        this._showLoading();
        this.queryParams.currPage = 1;
        this.queryParams.pageSize = 15;
        this.queryParams.name = "";
        this.queryParams.phone = "";
        scrollTo(0, 1000);
        let rsp = await CustApi.getMyInviteList({
          ...this.queryParams,
          currPage: this.currentPage,
          pageSize: this.pageSize,
        });
        this.data = rsp.data;
        this.total = rsp.total;
        this.judgementFinished();
        this.refreshing = false;
        this.loading = false;
      } catch (error) {
        setTimeout(() => {
          Toast("网络请求异常,请稍后重试");
        }, 0);
      } finally {
        this._dismissLoading();
      }
    },

    async search() {
      try {
        if (
          (this.queryParams.name.length == 0) &
          (this.queryParams.phone.length == 0)
        ) {
          setTimeout(() => {
            Toast("用户名和手机号请填写一个");
          }, 0);
          return;
        }
        this._showLoading();
        this.queryParams.currPage = 1;
        this.queryParams.pageSize = 15;
        let rsp = await CustApi.getMyInviteList({
          ...this.queryParams,
        });
        this.data = rsp.data;
        this.total = rsp.total;
        this.judgementFinished();
        this.refreshing = false;
        this.loading = false;
      } catch (error) {
        setTimeout(() => {
          Toast("网络请求异常,请稍后重试");
        }, 0);
      } finally {
        this._dismissLoading();
      }
    },

    async onload() {
      try {
        this._showLoading();
        this.loading = true;
        this.queryParams.currPage += 1;
        let rsp = await CustApi.getMyInviteList({
          ...this.queryParams,
        });
        this.total = rsp.total;
        this.data.push(...rsp.data);
        this.judgementFinished();
        this.loading = false;
      } catch (error) {
        let errorMessage = error.msg;
        this.loading = false;
        setTimeout(() => {
          Toast(errorMessage || "网络请求异常,请稍后重试");
        }, 0);
      } finally {
        this._dismissLoading();
      }
    },

    judgementFinished() {
      if (this.data.length == this.total) {
        this.finished = true;
      } else {
        this.finished = false;
      }
    },
    async onRefresh() {
      try {
        this.queryParams.currPage = 1;
        this.queryParams.pageSize = 15;
        this.refreshing = true;
        let rsp = await CustApi.getMyInviteList({
          ...this.queryParams,
        });
        this.data = rsp.data;
        this.total = rsp.total;
        this.judgementFinished();
        this.refreshing = false;
      } catch (error) {
        setTimeout(() => {
          Toast("网络请求异常,请稍后重试");
        }, 0);
      }
    },
  },

  computed: {
    pullRefreshStyle() {
      if (this.showSearch) {
        return "pull-refresh";
      } else {
        return "";
      }
    },
    ...mapGetters(["userInfo"]),
  },
};
</script>

<style lang="less">
.icon-text {
  line-height: 20px;
  font-size: 15px;
}

.pull-refresh {
  padding-top: 3.3rem;
}

.search-form {
  width: 100%;
  height: 3.1rem;
  position: fixed;
  z-index: 10;
  background: white;
  border-bottom: rgb(241, 245, 248) 10px solid;
}

.search-form .van-field__label {
  font-size: medium;
}

.search-form .van-field__control {
  font-size: medium;
}

.item-container {
  display: block;
  position: relative;
  background: #fff;
  border: 1px solid #fff;
  border-radius: 5px;
  box-shadow: 0 3px 3px #bdbdbd;
  border-top: 5px solid rgb(252, 101, 36);
}

.cell-value-class {
  font-size: small;
}

.search-btn {
  width: 3rem;
  margin-right: 5px;
}
</style>